/* eslint-disable react/no-array-index-key */
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";

import AddIcon from "@mui/icons-material/Add";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircleOutline";
import DeleteIcon from "@mui/icons-material/Delete";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
// import NextIcon from "@mui/icons-material/ArrowForward";

import FormField from "../../FormField";
import CompanyFilter from "../../filters/CompanyFilter";
import ProductFilter from "../../filters/ProductFilter";

import { IOccupant } from "../../../types/ILocation";
import NumberTextfield from "../../NumberTextfield";
import OccupantTypeFilter from "../../filters/OccupantTypeFilter";

const Occupant = ({
  key,
  index,
  occupant,
  setOccupant,
  deleteOccupant,
  uom,
  isOpen,
  onToggleOpen,
}: {
  key?: string;
  index: number;
  occupant: IOccupant;
  setOccupant: (o: IOccupant) => void;
  deleteOccupant: (index: number) => void;
  uom: string;
  isOpen: boolean;
  onToggleOpen: () => void;
}) => {
  return (
    <div
      key={key}
      style={{
        backgroundColor: "#F2F8FD",
        position: "relative",
        display: "flex",
        flexDirection: "column",
        gap: 15,
        padding: "15px 26px",
        paddingBottom: 20,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <div
          style={{
            color: "#OF2C52",
            fontSize: 10,
            fontWeight: 700,
            textTransform: "uppercase",
            flexGrow: 1,
          }}
        >
          {`Occupant ${index + 1}`}
        </div>

        <div
          style={{
            display: "flex",
            gap: 4,
            color: "#4B4B4B",
            fontSize: 10,
          }}
        >
          <div style={{ fontWeight: 700 }}>Total:</div>
          <div style={{ fontWeight: 400 }}>
            {`${occupant.products
              .reduce((acc, product) => acc + Number(product.quantity), 0)
              .toLocaleString()} ${uom}`}
          </div>
        </div>

        <div>
          <IconButton
            style={{ color: "#005CA6", padding: 0, margin: 0 }}
            onClick={onToggleOpen}
          >
            {isOpen ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </div>
      </div>

      {/* CLOSED */}
      <div
        style={{
          display: !isOpen ? "flex" : "none",
          justifyContent: "space-between",
        }}
      >
        {occupant.name && <div>{occupant.name}</div>}
        {!occupant.name && (
          <div style={{ fontStyle: "italic", color: "#595959" }}>
            Unknown occupant
          </div>
        )}

        <IconButton
          style={{ padding: 0, margin: 0 }}
          onClick={() => {
            deleteOccupant(index);
          }}
        >
          <DeleteIcon style={{ color: "rgba(197, 47, 0, 1)" }} />
        </IconButton>
      </div>

      {/* OPEN */}
      <div
        style={{
          display: isOpen ? "flex" : "none",
          flexDirection: "column",
          gap: 15,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            gap: 15,
          }}
        >
          {/* COLUMN 1 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "40%",
            }}
          >
            <FormField
              label="Occupant name"
              tooltip="Occupants who have been added in Salesforce"
            >
              <CompanyFilter
                value={occupant.name}
                setValue={(value) =>
                  setOccupant({
                    ...occupant,
                    name: value,
                  })
                }
              />
            </FormField>
          </div>

          {/* COLUMN 2 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 15,
              width: "35%",
            }}
          >
            {occupant.products.map((product, i: number) => (
              <div key={`productFilter-${product.product}-${i}`}>
                <FormField label="Product storage*">
                  <ProductFilter
                    value={product.product}
                    setValue={(value) => {
                      setOccupant({
                        ...occupant,
                        products: [
                          ...occupant.products.slice(0, i),
                          {
                            ...product,
                            product: value,
                          },
                          ...occupant.products.slice(i + 1),
                        ],
                      });
                    }}
                  />
                </FormField>
              </div>
            ))}
          </div>

          {/* COLUMN 3 */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 15,
              width: "30%",
            }}
          >
            {occupant.products.map((product, i) => (
              <div key={`storageQuantity-${product.product}-${i}`}>
                <FormField label="Storage quantity">
                  <div
                    style={{ display: "flex", alignItems: "center", gap: 6 }}
                  >
                    <NumberTextfield
                      size="small"
                      fullWidth
                      value={product.quantity}
                      setValue={(v) => {
                        setOccupant({
                          ...occupant,
                          products: [
                            ...occupant.products.slice(0, i),
                            {
                              ...product,
                              quantity: v,
                            },
                            ...occupant.products.slice(i + 1),
                          ],
                        });
                      }}
                    />

                    <IconButton
                      style={{
                        padding: 0,
                        margin: 0,
                      }}
                      onClick={() => {
                        setOccupant({
                          ...occupant,
                          products: occupant.products.filter(
                            (_, i2) => i2 !== i,
                          ),
                        });
                      }}
                    >
                      <RemoveCircleIcon
                        style={{ color: "rgba(197, 47, 0, 1)" }}
                      />
                    </IconButton>
                  </div>
                </FormField>
              </div>
            ))}
          </div>
        </div>

        <div style={{ display: "flex", alignItems: "flex-end", gap: 15 }}>
          <div
            style={{
              width: "40%",
              display: "flex",
              flexDirection: "column",
              gap: 10,
            }}
          >
            <div
              id="occupantTypeFilter"
              style={{ display: "flex", alignItems: "center", gap: 8 }}
            >
              <FormField label="Type">
                <OccupantTypeFilter
                  type={
                    occupant.types.length > 1 ? "Competitor" : occupant.types[0]
                  }
                  setType={(value) => {
                    setOccupant({
                      ...occupant,
                      types: [value],
                    });
                  }}
                />
              </FormField>
            </div>
          </div>

          <div
            style={{
              width: "35%",
            }}
          >
            <Button
              id="addOccupantProductButton"
              style={{
                display: "flex",
                alignItems: "center",
                gap: 4,
                textTransform: "uppercase",
              }}
              onClick={() => {
                setOccupant({
                  ...occupant,
                  products: [
                    ...occupant.products,
                    {
                      product: "",
                      quantity: 0,
                    },
                  ],
                });
              }}
            >
              <AddIcon style={{ fontSize: 18 }} />
              Add Product
            </Button>
          </div>
          <div style={{ width: "25%" }} />
        </div>

        {/* {addOccupant && (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div />
            <div style={{ display: "flex", alignItems: "flex-end" }}>
              <Button
                variant="contained"
                style={{ display: "flex", gap: 6, height: 34 }}
                onClick={nextOccupant}
                disabled={!isValid}
              >
                <NextIcon style={{ fontSize: 22 }} />
                NEXT OCCUPANT
              </Button>
            </div>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default Occupant;
